<template>
  <a-drawer
    :title="title"
    :maskClosable="false"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template>

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :label="language['user.column.userName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username">
          <a-input autocomplete="new-password" :placeholder="language['common.pleaseInput']+language['user.column.userName']" v-model="model.username" :disabled="!!model.id" :maxLength="maxLength"/>
        </a-form-model-item>

        <template v-if="!model.id">
          <a-form-model-item :label="language['user.column.password']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="password" >
            <a-input-password autocomplete="new-password" type="password" :placeholder="language['common.pleaseInput']+language['user.column.password']" v-model="model.password" :maxLength="maxLength" :disabled="disableSubmit"/>
          </a-form-model-item>

          <a-form-model-item :label="language['column.confirmPassword']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="confirmpassword" :disabled="disableSubmit">
            <a-input-password type="password" @blur="handleConfirmBlur" :placeholder="language['warning.passwordAgainRequired']" v-model="model.confirmpassword" :maxLength="maxLength" :disabled="disableSubmit"/>
          </a-form-model-item>
        </template>

        <a-form-model-item :label="language['user.column.realname']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="realname">
          <a-input :placeholder="language['common.pleaseInput']+language['user.column.realname']" v-model="model.realname" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-form-model-item :label="language['employee.column.englishName']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input  v-model="model.englishName" :placeholder="language['common.pleaseInput']+language['employee.column.englishName']" :maxLength="40"/>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.userType']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userType">
          <j-dict-select-tag type="radio" v-model="model.userType" @change="onChangeUserType" :trigger-change="true" dictCode="user_type_emp" :disabled="disableSubmit||!!model.id||userTypeDisable"/>
        </a-form-model-item>

        <a-form-model-item :label="language['common.company']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.userType==='nonemployee'">
          <a-input :placeholder="language['common.pleaseInput']+language['common.company']" v-model="model.companyName" :maxLength="100" :disabled="disableSubmit"/>
        </a-form-model-item>
        <div v-if="!(model.userType==='nonemployee')">
          <a-form-model-item :label="language['user.column.workNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="workNo" >
            <a-input :placeholder="language['common.pleaseInput']+language['user.column.workNo']" v-model="model.workNo" :maxLength="maxLength" :disabled="disableSubmit"/>
          </a-form-model-item>
        </div>

        <a-form-model-item :label="language['column.userRole.choose']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!roleDisabled" v-if="roleLoading&&!!model.id">
          <!--<j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.selectedroles"
            :options="rolesOptions"
            placeholder="请选择角色">
          </j-multi-select-tag>-->
          <!--<div v-for="item in apps" :value="item">
            {{item.name}}
          </div>-->
          <!--<j-select-role-for-apply-check v-model="item.roleIds"  :appId="item.id" :option="rolesOptions"></j-select-role-for-apply-check>-->
          <j-select-role-for-apllication v-model="model.selectedroles" :disabled="disableSubmit"
                                         :appId="apps?apps.join(','):''" :option="rolesOptions" :listUrl="roleListUrl"></j-select-role-for-apllication>

        </a-form-model-item>

<!--        <a-form-model-item :label="language['user.column.post']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-position :placeholder="language['common.pleaseChoose']+language['user.column.post']" :multiple="false" v-model="model.post" :disabled="disableSubmit"/>
        </a-form-model-item>-->

<!--        <a-form-model-item :label="language['businessGroupName']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.bg" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-form-model-item :label="language['businessUnitName']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.bu" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-form-model-item :label="language['depart']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.departName" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>-->
        <!--部门分配-->
        <a-form-model-item :label="language['user.column.deportChoose']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="!departDisabled && !(model.userType==='nonemployee') &&!!model.id" ><!--prop="selecteddeparts"-->
          <!--<j-select-depart v-model="model.selecteddeparts" :multi="true" @back="backDepartInfo" :backDepart="true" :treeOpera="true">></j-select-depart>-->
          <!--<j-select-depart-by-application v-model="model.selecteddeparts"
                                          :multi="true" @back="backDepartInfo"
                                          :applications="model.selectedApps"
                                          :backDepart="true" :treeOpera="true"></j-select-depart-by-application>-->
          <!--<j-select-depart-by-singleapplication application-code="env_audit"
                                                v-model="model.selecteddeparts"
                                                :multi="true" @back="backDepartInfo"
                                                :backDepart="true"
                                                :treeOpera="true"
                                                ></j-select-depart-by-singleapplication>-->
          <div><a-button @click="toSelectDeport" type="primary" icon="search" :disabled="disableSubmit">{{language['PlatForm.employee.chooseDepart']}}</a-button></div>
          <div v-for="(item,index) in selectedApps" :key="index" :value="item" v-if="!boo && item.selectedDepartNames">

             <span style="font-weight: 900;">{{item.applicationNameLanguage||item.applicationName}}</span> : {{item.selectedDepartNames}}
            <!--<a-icon  slot="suffix" type="close-circle" @click="handleEmpty" title="清空"/>-->

          </div>
          <div v-for="(item,index) in newselectedApps" :key="index" :value="item" v-if="boo && item.selectedDepartNames">
            <span style="font-weight: 900;">{{item.applicationNameLanguage||item.applicationName}}</span> : {{item.selectedDepartNames}}
          </div>
        </a-form-model-item>

        <!--租户分配-->
        <!--<a-form-model-item label="租户分配" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!departDisabled">
          <j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.relTenantIds"
            :options="tenantsOptions"
            placeholder="请选择租户">
          </j-multi-select-tag>
        </a-form-model-item>-->

        <a-form-model-item :label="language['user.column.userIdentity']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group  v-model="model.userIdentity"  @change="identityChange" :disabled="disableSubmit">
            <a-radio :value="1">{{ language['system.user.ordinaryUser'] }}</a-radio>
            <a-radio :value="2">{{ language['system.user.superiors'] }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :label="language['system.user.chargeDeport']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="departIdShow==true">
          <div><a-button @click="toSelectChargeDeport" type="primary" icon="search" :disabled="disableSubmit">{{language['PlatForm.employee.chooseDepart']}}</a-button></div>
          <div v-for="(item,index) in chargeDeparts" :key="index" :value="item">
            <span style="font-weight: 900;">{{item.applicationName}}</span> : {{item.selectedDepartNames}}
          </div>
<!--          <j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.departIds"
            :options="nextDepartOptions"
            placeholder="请选择负责部门">
          </j-multi-select-tag>-->
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.Avatar']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.avatar" :upload-source="uploadSource" :disabled="disableSubmit"></j-image-upload>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.birthday']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            :placeholder="language['warning.birthdayRequired']"
            v-model="model.birthday"
            :format="dateFormat"
            :disabled="disableSubmit"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.sex']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select :disabled="disableSubmit" v-model="model.sex"  :placeholder="language['warning.genderRequired']" :getPopupContainer= "(target) => target.parentNode">
            <a-select-option :value="1">{{language['common.sex.man']}}</a-select-option>
            <a-select-option :value="2">{{language['common.sex.woman']}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <div v-if="!(model.userType==='nonemployee')">
        <a-form-model-item :label="language['column.mailbox']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
          <a-input :placeholder="language['common.pleaseInput']+language['column.mailbox']" v-model="model.email" :maxLength="50" :disabled="disableSubmit"/>
        </a-form-model-item>
        </div>
        <div v-if="(model.userType==='nonemployee')">
        <a-form-model-item :label="language['column.mailbox']"  :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :placeholder="language['common.pleaseInput']+language['column.mailbox']" v-model="model.email" :maxLength="50" :disabled="disableSubmit"/>
        </a-form-model-item>
        </div>

        <a-form-model-item :label="language['user.column.phone']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone">
          <a-input :placeholder="language['common.pleaseInput']+language['user.column.phone']" v-model="model.phone" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.Landline']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px">
          <a-input :placeholder="language['warning.landlineNumberRequired']" v-model="model.telephone" :maxLength="maxLength" :disabled="disableSubmit"/>
        </a-form-model-item>

        <!--<a-form-model-item label="工作流引擎" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  v-model="model.activitiSync"  placeholder="请选择是否同步工作流引擎" :type="'radio'" dictCode="activiti_sync"/>
        </a-form-model-item>-->
        <a-form-model-item :label="language['PlatForm.employee.columns.costCode']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px" v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.costCode" :maxLength="maxLength" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.factoryName']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px" v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.factoryName" :maxLength="maxLength" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.empClass']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px" v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.empClass" :maxLength="maxLength" :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.companyName']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px" v-if="!(model.userType==='nonemployee')">
          <a-input  v-model="employee.companyName" :maxLength="maxLength" :disabled="true"/>
        </a-form-model-item>
        <a-col :span="24">
          <a-form-model-item :label="language['PlatForm.employee.columns.selectedAppids']" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-multi-select-tag :maxTagCount="20"
              v-model="model.selectedAppids"
              :options="appsOptions"
              :disabled="true"
              >
            </j-multi-select-tag>
          </a-form-model-item>
        </a-col>

        <a-col :span="24" style="height: 50px"></a-col>
      </a-form-model>
    </a-spin>


    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm :title="language['message.giveUpEditing']" @confirm="handleCancel" :okText="language['common.determineButton']" :cancelText="language['common.cancel']">
        <a-button style="margin-right: .8rem">{{language['common.cancel']}}</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">{{language['common.submitButton']}}</a-button>
    </div>
    <!--<j-select-depart-modal-by-singleapplication ref="departModalBySingleapplication" @ok="loadselectDeport"></j-select-depart-modal-by-singleapplication>-->
    <j-select-depart-modal-by-application ref="departSelectModalByApplication" @ok="loadselectDeport"></j-select-depart-modal-by-application>
    <j-select-depart-modal-by-application ref="chargeDepartSelectModalByApplication" @ok="loadselectChargeDeport"></j-select-depart-modal-by-application>
  </a-drawer>
</template>

<script>
  import moment from 'moment'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction,putAction,postAction } from '@/api/manage'
  import { addUser,editUser,queryUserRole,queryall } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import { duplicateCheck } from '@/api/api'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSelectDepartByApplication from "../../../components/jeecgbiz/JSelectDepartByApplication";
  import JSelectDepartModalByApplication from "../../../components/jeecgbiz/modal/JSelectDepartModalByApplication";
  import JSelectRoleForApplyCheck from '@/components/jeecgbiz/JSelectRoleForApplyCheck'
  import JSelectRoleForApllication from '@/components/jeecgbiz/JSelectRoleForApllication'

  import JSelectDepartModalBySingleapplication from "../../../components/jeecgbiz/modal/JSelectDepartModalBySingleapplication";
  import debounce from "lodash/debounce";

  export default {
    name: "UserModal",
    components: {
      JSelectDepartByApplication,
      JDictSelectTag,
      JSelectDepartModalByApplication,
      JSelectRoleForApplyCheck,
      JSelectRoleForApllication,
      JSelectDepartModalBySingleapplication,
    },
    data () {
      return {
        roleLoading:false,
        roleListUrl:'',
        apps:[],
        // uploadSource:"env",
        uploadSource:"platform",
        maxLength: 20,
        appsOptions:[],
        departDisabled: false, //是否是我的部门调用该页面
        roleDisabled: false, //是否是角色维护调用该页面
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        confirmDirty: false,
        userId:"", //保存用户id
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD",
        validatorRules:{
          username:[{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.userName']},
                    {validator: this.validateUsername,}],
          password: [
            {required: true,message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.password']},
            {validator: this.validateToNextPassword,trigger: 'change'}
          ],
          confirmpassword: [{required: true, message: this.$store.getters.language['warning.passwordAgainRequired'],},
                            { validator: this.$store.getters.compareToFirstPassword,}],
          realname:[{ required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.realname'] }],
          userType:[{ required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.userType'] }],
          // selecteddeparts:[{ required: true, message: '请选择部门!' }],
          phone: [ {validator: this.validatePhone}],
          email: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['column.mailbox'],trigger: 'change'}, {validator: this.validateEmail,trigger: 'change'}],
          workNo:[ { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.workNo'] },
                  { validator: this.validateWorkNo }],
          telephone: [{ pattern: /^\d{3,4}-[1-9]\d{3,9}$/, message: this.$store.getters.language['warning.landlineNumberFormatIncorrect'] },]
        },
        departIdShow:false,
        title:this.$store.getters.language['common.action'],
        visible: false,
        model: {},
        employee:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 },
        },
        uploadLoading:false,
        confirmLoading: false,
        headers:{},
        url: {
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
          userWithDepart: "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
          userId:"/sys/user/generateUserId", // 引入生成添加用户情况下的url
          syncUserByUserName:"/act/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
          queryTenantList: '/sys/tenant/queryList',
          checkUsernameAndWorkNoDuplicate: '/sys/user/checkUsernameAndWorkNoDuplicate',
        },
        tenantsOptions: [],
        rolesOptions:[],
        nextDepartOptions:[],


        userDepartWithApplication:[],
        selectedApps:[],
        newselectedApps:[],
        boo:false,

        chargeDeparts:[],
        userTypeDisable:false,
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      this.initRoleList();
      this.initAppList();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
    methods: {
      toSelectDeport(){
        let data1 = this.selectedApps
        let data2 = this.userDepartWithApplication
        this.$refs.departSelectModalByApplication.show(data1,data2)
        // this.$refs.departModalBySingleapplication.loadTree("env_audit","f3a61524d6ee459cb8c7dbfb820b0643")
      },
      toSelectChargeDeport(){
        let data1 = this.selectedApps
        let data2 = this.chargeDeparts
        this.$refs.chargeDepartSelectModalByApplication.show(data1,data2)
        // this.$refs.departModalBySingleapplication.loadTree("env_audit","f3a61524d6ee459cb8c7dbfb820b0643")
      },
      loadselectChargeDeport(data,rows){
        this.chargeDeparts = data;
      },
      loadselectDeport(data,rows){
        this.boo = true;
        let that = this;
        that.newselectedApps =[];
        for(let i=0;i<that.selectedApps.length;i++){
          for(let j=0;j<data.length;j++){
            if(data[j].applicationId==that.selectedApps[i].id){
              that.selectedApps[i].selectedDepartNames = data[j].selectedDepartNames
              break;
            }
          }
        }
        that.selectedApps.forEach(item=>{
          this.newselectedApps.push(item)
        })
        this.userDepartWithApplication = data
      },
      add () {
        this.refresh();
        this.edit({activitiSync:'1',userIdentity:1});
        if(this.$store.getters.application.applicationType !== 'platform') {
          this.model.selectedAppids = this.$store.getters.application.id;
        }
      },
      edit (record,appIds) {
        this.apps = appIds
        this.roleListUrl = '/sys/role/listByApplication?applicationIds='+(appIds?appIds.join(','):'');
        this.boo = false;
        this.employee = {};
        let that = this;
        this.initTenantList()
        that.visible = true;
        //根据屏幕宽度自适应抽屉宽度
        this.resetScreenSize();
        that.userId = record.id;
        that.model = Object.assign({},{selectedroles:'',selecteddeparts:'',selectedAppids:''}, record);
        that.selectedApps = [];
        //身份为上级显示负责部门，否则不显示
        if(this.model.userIdentity==2){
          this.departIdShow=true;
        }else{
          this.departIdShow=false;
        }

        if(record.hasOwnProperty("id")){
          that.getUserRoles(record.id);
          // that.getUserDeparts(record.id);
          that.getUserApplications(record.id);
          this.getEmployeeData(record.id);
        }else {
          this.roleLoading = true;
        }
      },
      isDisabledAuth(code){
        return disabledAuthFilter(code);
      },
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      //初始化租户字典
      initTenantList(){
        getAction(this.url.queryTenantList).then(res=>{
          if(res.success){
            this.tenantsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id+""}
              return c;
            })
          }
        })
      },
      //初始化角色字典
      initRoleList(){
        queryall().then((res)=>{
          if(res.success){
            this.rolesOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.roleName, value:item.id}
              return c;
            })
          }
        });
      },
      getUserRoles(userid){
        queryUserRole({userid:userid}).then((res)=>{
          if(res.success){
            this.model.selectedroles = res.result.join(",");
            this.roleLoading = true;
          }else{
            this.roleLoading = true;
          }
        });
      },
      getUserDeparts(userid,applicationIds,applicaitonList){
        this.userDepartWithApplication = [];
        let that = this;
        getAction(that.url.userWithDepart,{userId:userid}).then((res)=>{
          if(res.success){
            applicationIds.forEach(id=>{
              let map={};
              let selectDepart=[]
              let selectDepartNames = "";
              for (let i = 0; i < res.result.length; i++) {
                let value = res.result[i];
                if(value.applicationId == id){
                  selectDepart.push(value.key);
                  if(selectDepartNames == ""){
                    selectDepartNames = value.title;
                  }else{
                    selectDepartNames = selectDepartNames+"\u00A0 |\u00A0 "+value.title;
                  }
                }
                // selectDepartKeys.push(res.result[i].key);
                //新增负责部门选择下拉框
                /*departOptions.push({
                  value: res.result[i].key,
                  label: res.result[i].title
                })*/
              }
              map.applicationId = id;
              map.selectedDeparts = selectDepart;
              map.selectedDepartNames = selectDepartNames;
              this.userDepartWithApplication.push(map);
              if(applicaitonList.length>0){
                applicaitonList.forEach(item=>{
                  if(item.id == id)item.selectedDepartNames = selectDepartNames
                })
              }
              this.selectedApps = applicaitonList;
            })
            // that.model.selecteddeparts = selectDepartKeys.join(",")
            // that.nextDepartOptions=departOptions;
            // console.log('that.nextDepartOptions=',that.nextDepartOptions)

          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      refresh () {
        this.userId=""
        this.nextDepartOptions=[];
        this.departIdShow=false;
      },
      close () {
        // if(this.roleDisabled)this.$emit('cleanUserName');
        this.$emit('close');
        this.roleLoading = false;
        this.visible = false;
        this.disableSubmit = false;
        this.nextDepartOptions=[];
        this.departIdShow=false;
        this.$refs.form.resetFields();
      },
      moment,
      handleSubmit: debounce(function() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            //如果是上级择传入departIds,否则为空
            if(this.model.userIdentity!==2){
              this.model.departIds="";
            }
            this.model.employee = this.employee
            let obj;
            if(!this.model.id){
              this.model.id = this.userId;
              obj=addUser(this.model);
            }else{
              obj=editUser(this.model);
            }
            obj.then((res)=>{
              if(res.success){
                if(this.userId){
                  let map = {};
                  map.data=this.userDepartWithApplication
                  map.userId = this.userId
                  putAction("/sys/UserDepart/addList", map).then((res)=> {
                    if (res.success) {
                      let map2 = {};
                      map2.data=this.chargeDeparts
                      map2.userId = this.userId
                      postAction("/sys/sysuserchargedeparts/saveData", map2).then((res)=> {
                        if (res.success) {
                          that.$message.success(res.message);
                          that.$emit('ok');
                          if(that.roleDisabled)that.$emit('cleanUserName');
                        }
                      })
                    }
                  })
                }else{
                  that.$message.success(res.message);
                  that.$emit('ok');
                  if(that.roleDisabled)that.$emit('cleanUserName');
                }
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      }, 3000),
      handleCancel () {
        this.close()
      },
      validateToNextPassword (rule, value, callback) {
        if(this.model.id){
          callback()
          return
        }
        if(value) {
          if (/[\u4E00-\u9FA5]/g.test(value)) {
            callback(new Error(this.language['common.front.apply.cannot.chinese']));
          } else if (!(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(value))) {
            callback(new Error(this.language['warning.passwordConsists']));
          } else {
            const confirmpassword = this.model.confirmpassword;
            if (value && confirmpassword && value !== confirmpassword) {
              callback(this.language['warning.passwordEnteredTwiceDifferent']);
            }
            if (value && this.confirmDirty) {
              this.$refs.form.validateField(['confirmpassword']);
            }
            callback();
          }
        }else{
          callback(this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.password'])
        }
      },
      compareToFirstPassword (rule, value, callback) {
        if(this.model.id){
          callback()
          return
        }
        if(value) {
          if (/[\u4E00-\u9FA5]/g.test(value)) {
            callback(new Error(this.language['common.front.apply.cannot.chinese']));
          } else {
            if (value && value !== this.model.password) {
              callback(this.language['warning.passwordEnteredTwiceDifferent']);
            } else {
              callback()
            }
          }
        }else{
          callback(this.$store.getters.language['warning.passwordAgainRequired'])
        }
      },
      validatePhone(rule, value, callback){
        let that = this;
        if(!value){
          callback()
        }else{
         // if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            let params = {
              id: this.userId,
              phone: value
            };
            getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
              if (res.success) {
                callback()
              } else {
                callback(this.language["warning.phoneNumberAlreadyExists"])
              }
            })
            /*var params = {
              tableName: 'sys_user',
              fieldName: 'phone',
              fieldVal: value,
              dataId: this.userId
            };
            duplicateCheck(params).then((res) => {
              if (res.success) {
                callback()
              } else {
                callback("手机号已存在!")
              }
            })*/
          // }else{
          //   callback("请输入正确格式的手机号码!");
          // }
        }
      },
      validateEmail(rule, value, callback){
        let that = this;
        if(!value){
          callback()
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            //2022/3/10 不校验邮箱唯一性，公司内部存在共用邮箱的情况
            callback();
            /*let params = {
              id: this.userId,
              email: value
            };
            getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
              if (res.success) {
                callback()
              } else {
                callback("邮箱已存在!")
              }
            })*/
            /*var params = {
              tableName: 'sys_user',
              fieldName: '',
              fieldVal: value,
              dataId: this.userId
            };
            duplicateCheck(params).then((res) => {
              console.log(res)
              if (res.success) {
                callback()
              } else {
                callback("!")
              }
            })*/
          }else{
            callback(this.language["warning.emailFormatIncorrect"])
          }
        }
      },
      validateForbidUsername(username,callback){
        getAction("/sys/dictItem/allList",{dictCode:'platform_black_accout'}).then(res=> {
          if (res.success) {
            let list = res.result;
            for(var i=0;i<list.length;i++){
              let item = list[i];
              if(item.value.trim() == username.trim()){
                callback(this.language["system.warning.forbidUsername"]);
              }
            }
            callback()
          }
        })
      },
      validateUsername(rule, value, callback){
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error(this.language['common.front.apply.cannot.chinese']));
        } else {
          let that = this;
          let params = {
            id: this.userId,
            username: value
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
            if (res.success) {
              // callback()
              this.validateForbidUsername(value,callback)
            } else {
              callback(this.language["warning.usernameAlreadyExists"])
            }
          })
        }
      },
      validateWorkNo(rule, value, callback){
        if(!value){
          callback(this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.workNo']);
        }
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error(this.language['common.front.apply.cannot.chinese']));
        } else {
          let that = this;
          let params = {
            id: this.userId,
            workNo: value
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
            if (res.success) {
              callback()
            } else {
              callback(this.language["warning.jobNumberAlreadyExists"])
            }
          })
        }
      },
      handleConfirmBlur(e) {
        const value = e.target.value;
        this.confirmDirty = this.confirmDirty || !!value
      },
      beforeUpload: function(file){
        var fileType = file.type;
        if(fileType.indexOf('image')<0){
          this.$message.warning(this.language['warning.pleaseUploadImage']);
          return false;
        }
        //TODO 验证文件大小
      },
      identityChange(e){
        if(e.target.value===1){
            this.departIdShow=false;
        }else{
            this.departIdShow=true;
        }
      },

      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllApps").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationNameLanguage||item.applicationName, value:item.id}
              return c;
            })
          }
        })
      },
      getUserApplications(userId){
        let params = {
          id: userId,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=>{
          if (res.success) {
            let list = res.result;
            let ids = "";
            if(list){
              list.forEach(item=>{
                if(ids == ""){
                  ids = item.id;
                }else{
                  ids = ids+","+item.id;
                }
              })
            }
            // this.selectedApps = list;
            this.model.selectedAppids = ids;
            this.getUserDeparts(userId,ids.split(","),list);
            this.getUserChargedeparts(userId,ids)
          }
        })
      },
      getUserChargedeparts(userid,applicationIds){
        this.chargeDeparts = [];
          getAction("/sys/sysuserchargedeparts/getlistByUserId",{userId:userid,applicationIds:applicationIds}).then(res=>{
          if(res.success){
            this.chargeDeparts = res.result;
          }
        })
      },
      getEmployeeData(userId){
        getAction("/sys/employee/queryById",{id:userId}).then((res)=>{
          if(res.success){
            this.employee = res.result;
          }
        })
      },
      onChangeUserType(){
        this.$refs.form.clearValidate();
      }
    }
  }
</script>

<style scoped>
  .components-input-demo-presuffix .anticon-close-circle {
    cursor: pointer;
    color: #ccc;
    transition: color 0.3s;
    font-size: 12px;
  }
  .components-input-demo-presuffix .anticon-close-circle:hover {
    color: #f5222d;
  }
  .components-input-demo-presuffix .anticon-close-circle:active {
    color: #666;
  }
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>